import * as v from 'valibot';

export const stringRequiredSchema = v.pipe(
  v.string('Veld is verplicht'),
  v.minLength(1, 'Veld is verplicht'),
)
